/**
 * Каноничный URL приложения.
 * Используется для генерации ссылок (sharing, referral, redirects),
 * чтобы они были корректными независимо от технического домена хостинга.
 */
export const APP_URL = 'https://top-focus.ru';
